import { render, staticRenderFns } from "./trainingCenter.vue?vue&type=template&id=58983915&scoped=true&"
import script from "./trainingCenter.vue?vue&type=script&lang=js&"
export * from "./trainingCenter.vue?vue&type=script&lang=js&"
import style0 from "./trainingCenter.vue?vue&type=style&index=0&id=58983915&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58983915",
  null
  
)

export default component.exports